module.exports = __webpack_public_path__ + "assets/img/all_award_Bg.98025768.png";